<!--我的页面-->
<template>
    <div class="idWQ">
        <div class="boxTop">
            <div class="title" style="padding-top: 0;">
                <div>{{ $t('从') }}</div>
            </div>
            <div class="universal" @click="CyPicker = true">
                <div>{{ fromCurrency }}</div>
                <van-icon name="arrow-down" />
            </div>

            <div class="title">
                <div>{{ $t('至') }}</div>
            </div>
            <div class="universal" @click="toPicker = true">
                <div>{{ toCurrency }}</div>
                <van-icon name="arrow-down" />
            </div>

            <div class="title">{{ $t('币种') }}</div>
            <div class="universal" @click="showPicker = true">
                <div>{{ currencyZ }}</div>
                <van-icon name="arrow-down" />
            </div>

            <div class="title">{{ $t('划转数量') }}</div>
            <div class="universal">
                <van-field v-model="quantity" :placeholder="$t('请输入划转数量')" :border="false" />
                <div @click="allCk" style="color: #07ecfe;white-space: nowrap;">{{ $t('全部') }}</div>
            </div>
            <div style="padding-top: 8px;color: #999999;">{{ $t('余额') }}: {{ balance || 0 }}</div>

            <van-button class="btn" type="primary" @click="transfer">{{ $t('划转') }}</van-button>
        </div>

        <div class="boxTop">
            <div style="font-size: 18px;padding-top: 10px;">{{ $t('划转记录') }}</div>
            <div class="table">
                <!-- 表头 -->
                <van-row class="header">
                    <van-col span="5" class="vanItem">{{ $t('时间') }}</van-col>
                    <van-col span="4" class="vanItem">{{ $t('币种') }}</van-col>
                    <van-col span="5" class="vanItem">{{ $t('数量') }}</van-col>
                    <van-col span="5" class="vanItem">{{ $t('从') }}</van-col>
                    <van-col span="5" class="vanItem">{{ $t('至') }}</van-col>
                </van-row>
                <!-- 数据 -->
                <div class="scroll">
                    <van-row v-for="(item, index) in usersList" :key="index + 'a'" class="row">
                        <van-col span="5" class="trade">
                            {{ item.createtime }}
                        </van-col>
                        <van-col span="4" class="trade">
                            {{ item.coin_name }}
                        </van-col>
                        <van-col span="5" class="trade">
                            {{ item.amount }}
                        </van-col>
                        <van-col span="5" class="trade">
                            {{ item.from_account }}
                        </van-col>
                        <van-col span="5" class="trade">
                            {{ item.to_account }}
                        </van-col>
                    </van-row>
                </div>
            </div>
        </div>

        <van-popup v-model="CyPicker" position="bottom">
            <van-picker show-toolbar :columns="toColumns" @confirm="CyConfirm" @cancel="CyPicker = false"
                value-key="name" :confirm-button-text="$t('确认')" :cancel-button-text="$t('取消')"/>
        </van-popup>

        <van-popup v-model="toPicker" position="bottom">
            <van-picker show-toolbar :columns="toColumns" @confirm="toConfirm" @cancel="toPicker = false"
                value-key="name" :confirm-button-text="$t('确认')" :cancel-button-text="$t('取消')"/>
        </van-popup>

        <van-popup v-model="showPicker" position="bottom">
            <van-picker show-toolbar :columns="columnsT" @confirm="onConfirm" @cancel="showPicker = false"
                value-key="name" :confirm-button-text="$t('确认')" :cancel-button-text="$t('取消')"/>
        </van-popup>

    </div>
</template>
<script>
import { post } from '@/http/request'
import apis from '@/http/api'
export default {
    props: {
        columnsT: {
            type: Array,
            default: () => []
        },
        toColumns: {
            type: Array,
            default: () => []
        },
        usersList: {
            type: Array,
            default: () => []
        }
    },
    watch: {
        // 监听 usersList 数据变化
        toColumns: {
            handler(newVal, oldVal) {
                console.log("usersList 改变了:", newVal, oldVal);
                let value = newVal.filter(item => item.code === this.fromCode)
                this.balance = value[0].value
            },
            deep: true, // 深度监听
            immediate: true // 组件加载时立即执行
        }
    },
    components: {

    },
    data() {
        return {
            quantity: '',
            balance: '',
            showPicker: false,
            toPicker: false,
            CyPicker: false,

            fromCurrency: this.$t('请选择'),
            toCurrency: this.$t('请选择'),
            currencyZ: this.$t('请选择'),

            currencyId: '',
            currencyCode: '',
            fromCode: ""
        };
    },
    mounted() {

    },
    beforeUnmount() { },
    methods: {
        async transfer() {
            const res = await post(apis.moneyTransfer, { from_account: this.fromCode, to_account: this.currencyCode, amount: this.quantity, coin_id: this.currencyId })
            if (res.code == 1) {
                this.quantity = ''
                this.$toast(res.msg);
                setTimeout(() => {
                    this.$emit('transferList')
                    this.$emit('transferData')
                }, 1200)
                return
            }
            this.$toast(res.msg);
        },
        allCk() {
            this.quantity = this.balance
        },
        onConfirm(value) {
            this.currencyZ = value.name
            this.currencyId = value.id
            this.showPicker = false
        },
        toConfirm(value) {
            this.toCurrency = value.name
            this.currencyCode = value.code
            this.toPicker = false
        },
        CyConfirm(value) {
            this.fromCurrency = value.name
            this.fromCode = value.code
            this.balance = value.value
            this.CyPicker = false
        },


    },
};
</script>
<style lang="less" scoped>
::v-deep .van-cell {
    padding: 0;
}

.idWQ {
    color: #fff;
    padding-bottom: 20px;
    font-size: 14px;

    .navBar {
        background-color: #090d13;
        padding: 15px 10px;
        font-size: 18px;
        font-weight: 700;
        border-radius: 4px;
    }

    .boxTop {
        padding: 10px;
        border-radius: 10px;
        border: 1px solid #2c2c3e;
        margin-top: 20px;
    }



    .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 20px;
        font-weight: 700;
    }

    .btn {
        width: 100%;
        margin: 10px 0;
        background-color: #07ecfe;
        border-radius: 5px;
        color: #000;
    }

    .table {
        background: #000;
        color: #fff;
        margin-top: 20px;
        font-size: 12px;

        .header {
            background: #1c222c;
            padding: 10px 0;
            border-radius: 5px;

            .vanItem {
                text-align: center;
            }
        }

        .scroll {
            overflow-y: auto;
            height: 45vh;
            scrollbar-width: none;
            /* Firefox */
            -ms-overflow-style: none;
            /* IE/Edge */
        }

        .row {
            border-bottom: 1px solid #222b39;
            padding: 10px 0px;
            display: flex;
            align-items: center;
            font-size: 11px;

            .trade {
                text-align: center;
            }
        }
    }

    .universal {
        padding: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border: 1px solid #3a3f47;
        margin-top: 10px;
        border-radius: 5px;
    }

}
</style>
